import { Translation } from '../types';

export const hr: Translation = {
  common: {
    loading: 'Učitavanje...',
    error: 'Greška',
    cancel: 'Odustani',
    save: 'Spremi',
    close: 'Zatvori',
    search: 'Pretraži',
    reload: 'Učitaj ponovno',
    logout: 'Odjava',
    dashboard: 'Nadzorna ploča',
    products: 'Proizvodi',
    settings: 'Postavke',
    language: 'Jezik',
    businessHours: 'Radno vrijeme',
    back: 'Natrag',
    selectAll: 'Odaberi sve',
    deselectAll: 'Poništi odabir',
    success: 'Uspjeh',
    selected: 'Odabrano',
    confirm: 'Potvrdi',
    required: 'Obavezno',
    requiredMarker: '*',
    previous: 'Prethodno',
    next: 'Sljedeće',
    allRightsReserved: 'Sva prava pridržana.',
  },
  auth: {
    login: 'Prijava',
    email: 'Adresa e-pošte',
    password: 'Lozinka',
    loginButton: 'Prijava',
    loggingIn: 'Prijava u tijeku...',
    loginSuccess: 'Prijava uspješna',
    loginError: 'E-pošta ili lozinka nisu ispravni',
    invalidEmail: 'Molimo unesite valjanu adresu e-pošte',
    requiredFields: 'Molimo unesite e-poštu i lozinku',
    demoAccount: 'Demo račun:',
    loginDescription: 'Unesite podatke o računu za prijavu',
    welcomeMessage: 'Dobrodošli u sustav naručivanja za poslovne partnere',
    // Registration
    register: 'Registracija',
    createAccount: 'Izradi račun',
    confirmPassword: 'Potvrdi lozinku',
    passwordRequirements: 'Lozinka mora imati najmanje 8 znakova s velikim i malim slovima, brojem i posebnim znakom',
    passwordsDoNotMatch: 'Lozinke se ne podudaraju',
    registrationSuccess: 'Registracija uspješna',
    registrationDescription: 'Registrirajte se za poslovni račun',
    alreadyHaveAccount: 'Već imate račun?',
    signIn: 'Prijavite se',
    dontHaveAccount: 'Nemate račun?',
    creatingAccount: 'Izrada računa...',
    registrationNote: 'Napomena:',
    registrationNotePoints: {
      erpLinking: 'Ako imate postojeći poslovni račun, vaša e-pošta bit će automatski povezana',
      companyEmail: 'Molimo koristite adresu e-pošte vaše tvrtke za registraciju',
      contactSupport: 'Kontaktirajte podršku ako trebate pomoć pri registraciji'
    },
    b2bUsers: 'Korisnici poslovnog računa:',
    registeredEmail: 'Registrirana adresa e-pošte',
    registeredPassword: 'Lozinka postavljena prilikom registracije',
    b2bCustomerRequired: 'Ova adresa e-pošte nije registrirana kao poslovni kupac. Molimo kontaktirajte prodaju kako biste prvo uspostavili poslovni odnos.',
    b2bVerificationError: 'Nije moguće provjeriti status poslovnog kupca. Molimo kontaktirajte podršku.',
    // Password Reset
    passwordReset: 'Ponovno postavljanje lozinke',
    passwordResetDescription: 'Unesite svoju adresu e-pošte kako biste dobili privremenu lozinku',
    getTemporaryPassword: 'Dobijte privremenu lozinku',
    processing: 'Obrada...',
    passwordResetComplete: 'Ponovno postavljanje lozinke dovršeno',
    temporaryPasswordGenerated: 'Privremena lozinka je generirana',
    temporaryPassword: 'Privremena lozinka',
    backToLogin: 'Natrag na prijavu',
    securityNotice: 'Sigurnosna napomena:',
    securityNotePoints: {
      keepSecret: 'Ne dijelite privremenu lozinku s drugima',
      changeAfterLogin: 'Obavezno promijenite lozinku nakon prijave',
      expires24Hours: 'Privremena lozinka istječe nakon 24 sata'
    },
    resetNote: 'Napomena:',
    resetNotePoints: {
      registeredEmail: 'Unesite svoju registriranu adresu e-pošte',
      passwordDisplayed: 'Privremena lozinka bit će prikazana na ekranu',
      changeRequired: 'Promjena lozinke je obavezna nakon prijave'
    },
    copied: 'Kopirano',
    copySuccessMessage: 'Privremena lozinka kopirana u međuspremnik.',
    forgotPassword: 'Zaboravljena lozinka?',
    // Password Reset Email Request
    sendResetLink: 'Pošalji poveznicu za resetiranje',
    sendingEmail: 'Slanje e-pošte...',
    emailSent: 'E-pošta poslana',
    emailSentMessage: 'Ako ova adresa e-pošte postoji u našem sustavu, uskoro ćete primiti poveznicu za ponovno postavljanje lozinke.',
    emailNotSent: 'E-pošta nije poslana',
    emailSentInfo: 'Provjerite pristiglu poštu i mapu neželjene pošte',
    checkEmail: 'Provjerite e-poštu',
    emailInstructions: 'Upute za ponovno postavljanje lozinke su poslane',
    nextSteps: 'Sljedeći koraci:',
    nextStepsList: {
      checkInbox: 'Provjerite pristiglu poštu i mapu neželjene pošte',
      clickLink: 'Kliknite na poveznicu za resetiranje u e-pošti',
      linkExpires: 'Poveznica istječe za 24 sata',
      contactSupport: 'Kontaktirajte podršku ako ne primite e-poštu',
      rateLimitInfo: 'Ograničeno na 3 zahtjeva po satu'
    },
    // Password Reset Completion
    resetLinkSent: 'Poveznica za resetiranje poslana',
    resetSuccess: 'Lozinka uspješno resetirana',
    passwordUpdated: 'Lozinka ažurirana',
    passwordUpdateMessage: 'Vaša lozinka je uspješno ažurirana. Sada se možete prijaviti s novom lozinkom.',
    loginWithNewPassword: 'Prijava s novom lozinkom',
    // Reset Token Page
    resetToken: 'Resetiraj lozinku',
    invalidToken: 'Nevažeći token za resetiranje',
    expiredToken: 'Token za resetiranje je istekao',
    tokenValid: 'Token za resetiranje je valjan',
    newPassword: 'Nova lozinka',
    confirmNewPassword: 'Potvrdi novu lozinku',
    updatePassword: 'Ažuriraj lozinku',
    updatingPassword: 'Ažuriranje lozinke...',
    passwordMismatch: 'Lozinke se ne podudaraju',
    resetInstructions: 'Unesite svoju novu lozinku kako biste dovršili resetiranje',
  },
  accountInfo: {
    title: 'Podaci o računu',
    loading: 'Učitavanje podataka o računu...',
    error: 'Greška',
    errorMessage: 'Neuspjelo dohvaćanje podataka o računu',
    back: 'Natrag',
    basicInfo: 'Osnovni podaci',
    name: 'Ime',
    email: 'Adresa e-pošte',
    contactId: 'Knitido ID kupca',
    contactNumber: 'Kontakt broj',
    noInfo: 'Nema podataka',
    companyInfo: 'Podaci o tvrtki',
    company: 'Naziv tvrtke',
    position: 'Pozicija',
    vatId: 'PDV ID',
    billingAddress: 'Adresa za naplatu',
    deliveryAddress: 'Adresa za dostavu',
    addressInfo: 'Podaci o adresi',
    billingDescription: 'Adresa za račune i ugovorne dokumente',
    deliveryDescription: 'Standardna adresa za isporuku proizvoda',
    sameAsBilling: '※ Isto kao adresa za naplatu',
    sameAsDelivery: '※ Isto kao adresa za dostavu',
    companyName: 'Naziv tvrtke',
    contactPerson: 'Kontakt osoba',
    address: 'Adresa',
    phoneNumber: 'Broj telefona',
    billingUsage: 'Koristi se kao odredište za račune, ugovore i druge važne dokumente',
    deliveryUsage: 'Koristi se kao standardna adresa za isporuku naručenih proizvoda',
    alsoUsedForDelivery: 'Također se koristi kao odredište za dostavu',
    accountType: 'Vrsta računa',
    addressId: 'ID adrese',
    // Address editing functionality
    edit: 'Uredi',
    editDeliveryAddress: 'Uredi adresu za dostavu',
    editDeliveryDescription: 'Ažurirajte podatke svoje adrese za dostavu',
    newDeliveryAddress: 'Dodaj novu adresu za dostavu',
    newDeliveryDescription: 'Unesite detalje za svoju novu adresu za dostavu',
    noDeliveryAddress: 'Nema postavljene adrese za dostavu',
    success: 'Uspjeh',
    addressUpdated: 'Adresa za dostavu uspješno ažurirana',
    updateError: 'Neuspjelo ažuriranje adrese za dostavu',
    requiredFields: 'Molimo ispunite sva obavezna polja',
    firstName: 'Ime',
    lastName: 'Prezime',
    streetAddress: 'Adresa ulice',
    streetAddress2: 'Adresa ulice 2',
    city: 'Grad',
    country: 'Država',
    selectCountry: 'Odaberite državu...',
    searchCountry: 'Pretraži državu...',
    noCountryFound: 'Država nije pronađena.',
    postalCode: 'Poštanski broj',
    companyNamePlaceholder: 'Unesite naziv tvrtke',
    firstNamePlaceholder: 'Ime',
    lastNamePlaceholder: 'Prezime',
    streetAddressPlaceholder: 'Unesite adresu ulice',
    streetAddress2Placeholder: 'Stan, apartman, itd.',
    cityPlaceholder: 'Unesite grad',
    postalCodePlaceholder: 'Unesite poštanski broj',
    billingNotEditable: 'Adresa za naplatu se ne može uređivati.',
    billingContactSupport: 'Kontaktirajte podršku za promjene.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} adresa za dostavu',
    noDeliveryAddresses: 'Nema registriranih adresa za dostavu',
    defaultAddress: 'Zadano',
    selectDeliveryAddress: 'Odaberite adresu za dostavu',
    addNewAddress: 'Dodaj novu adresu',
    editAddress: 'Uredi adresu',
    deleteAddress: 'Obriši adresu',
    confirmDelete: 'Potvrdi brisanje',
    confirmDeleteMessage: 'Jeste li sigurni da želite obrisati ovu adresu? Ova radnja se ne može poništiti.',
    addressAddedSuccess: 'Adresa za dostavu dodana',
    addressDeletedSuccess: 'Adresa za dostavu obrisana',
    deleteError: 'Neuspjelo brisanje adrese za dostavu',
    saving: 'Spremanje...',
    cancel: 'Odustani',
    saveChanges: 'Spremi promjene',
    selectedDeliveryAddress: 'Odabrana adresa za dostavu',
  },
  dashboard: {
    title: 'Poslovni partner',
    subtitle: 'Sustav za naručivanje proizvoda',
    welcome: 'Dobrodošli,',
    welcomeMessage: 'Dobrodošli u sustav naručivanja za poslovne partnere. Ovdje možete naručiti proizvode.',
    productCatalog: 'Katalog proizvoda',
    productCatalogDesc: 'Pregledajte i naručite dostupne proizvode',
    viewProducts: 'Pregledaj proizvode',
    orderHistory: 'Povijest narudžbi',
    orderHistoryDesc: 'Pregledajte prošle narudžbe (uskoro)',
    accountSettings: 'Postavke računa',
    accountSettingsDesc: 'Upravljajte podacima o računu (uskoro)',
    comingSoon: 'Uskoro',
    infoTitle: 'O korištenju',
    orderingInfo: 'Naručivanje proizvoda',
    orderingDesc: 'Odaberite proizvode iz kataloga i navedite veličinu i boju. Dostupne su informacije o zalihama u stvarnom vremenu.',
    supportInfo: 'Podrška',
    supportDesc: 'Ako imate bilo kakvih pitanja, slobodno nas kontaktirajte.',
    viewOrderHistory: 'Pregledaj povijest narudžbi',
    viewOrders: 'Pregledaj narudžbe',
    accountInfo: 'Podaci o računu',
    accountInfoDesc: 'Pregledajte detalje svog računa',
    viewDetails: 'Pregledaj detalje',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Ponedjeljak-Petak 9:00 - 15:00 CET',
    bulkImportDesc: 'Uvoz narudžbi iz Excel/CSV datoteka',
    importOrders: 'Uvezi narudžbe',
  },
  products: {
    title: 'Popis proizvoda',
    subtitle: 'Poslovni partner',
    searchPlaceholder: 'Pretraži po nazivu proizvoda ili SKU...',
    productId: 'ID proizvoda',
    addToCart: 'Dodaj u košaricu',
    selectVariation: 'Odaberi varijaciju',
    price: 'Cijena',
    priceNetNotice: 'Sve cijene su neto cijene',
    stock: 'Zaliha',
    color: 'Boja',
    newProducts: 'Novi proizvodi',
    newProductBadge: 'NOVO',
    size: 'Veličina',
    quantity: 'Količina',
    total: 'Ukupno',
    cart: 'Košarica',
    checkout: 'Blagajna',
    csvMode: 'CSV Brzi način rada',
    csvInfo: 'Podaci o proizvodima preuzeti iz CSV podataka',
    csvUploadDate: 'Datum učitavanja CSV-a:',
    stockNote: '※ Informacije o zalihama preuzimaju se prilikom odabira varijacija proizvoda',
    noProducts: 'Nema pronađenih proizvoda',
    noProductsDesc: 'Promijenite kriterije pretraživanja ili prenesite CSV datoteku za brže performanse.',
    retry: 'Pokušaj ponovno',
    pagination: 'stavki',
    variations: 'varijacije',
    stockFetchError: 'Greška pri dohvaćanju zaliha',
    stockFetchFailed: 'Dohvaćanje zaliha nije uspjelo',
    stockFetchFailedDesc: 'Nije moguće dohvatiti informacije o zalihama. Prikazat će se CSV zalihe.',
    stockFetched: 'Informacije o zalihama preuzete',
    totalStock: 'Ukupna zaliha',
    noStockAll: 'Sve varijacije imaju nula zaliha',
    noStockData: 'Nema vraćenih podataka o zalihama',
    stockFetchErrorDesc: 'Došlo je do greške prilikom dohvaćanja informacija o zalihama',
    selectionError: 'Greška pri odabiru',
    enterQuantity: 'Molimo unesite količinu',
    addedToCart: 'Dodano u košaricu',
    typesAdded: ' vrsta proizvoda dodano',
    addToCartError: 'Greška pri dodavanju u košaricu',
    addToCartErrorDesc: 'Molimo pokušajte ponovo',
    loadingStock: 'Učitavanje informacija o zalihama',
    csvDataInfo: 'Prikazivanje informacija iz CSV podataka (ne stvarne razine zaliha)',
    invalidDataFormat: 'Format podataka o proizvodu nije valjan',
    loadFailed: 'Neuspjelo učitavanje podataka o proizvodu',
    csvUploadComplete: 'CSV prijenos završen',
    csvLoadedDesc: ' podataka o proizvodima učitano. Informacije o zalihama bit će preuzete prilikom odabira proizvoda.',
    searchTitle: 'Pretraživanje proizvoda',
    loadingProducts: 'Učitavanje podataka o proizvodima',
    noProductsCsv: 'Nema pronađenih proizvoda u CSV podacima. Molimo promijenite kriterije pretraživanja.',
    paginationDisplay: ' prikazano',
    previous: 'Prethodno',
    next: 'Sljedeće',
    selectionSummary: 'Sažetak odabira',
    selectedQuantity: 'Odabrana količina',
    items: ' stavki',
    viewDetails: 'Pregledaj detalje',
    productImage: 'Slika proizvoda',
    correspondingVariations: 'Odgovarajuće varijacije',
    clickToEnlarge: 'Kliknite za povećanje',
    productIdLabel: 'ID proizvoda',
    colorLabel: 'Boja',
    filterByCategory: 'Filtriraj po kategoriji',
    allProducts: 'Svi proizvodi',
    applyFilters: 'Primijeni filtere',
    clearFilters: 'Očisti filtere',
    filters: 'Filteri',
    clearAll: 'Očisti sve',
  },
  categories: {
    category_21: 'Čarape s prstima',
    category_23: 'Nekategorizirano',
    category_24: 'Odjeća',
    category_29: 'B2B Proizvodi',
  },
  productDetail: {
    title: 'Detalji proizvoda',
    backToProducts: 'Natrag na proizvode',
    productNotFound: 'Proizvod nije pronađen',
    productNotFoundDesc: 'Navedeni proizvod ne postoji ili je obrisan.',
    loading: 'Učitavanje proizvoda...',
    imageLoadError: 'Neuspjelo učitavanje slika',
    noImages: 'Nema dostupnih slika',
    productDescription: 'Opis proizvoda',
    colors: 'Boje',
    sizes: 'Veličine',
    colorCount: 'boja',
    sizeCount: 'veličina',
    variationCount: 'varijacija',
    selectVariation: 'Odaberi varijacije',
    descriptionLanguageNote: '※ Opisi proizvoda dostupni su samo na engleskom ili njemačkom jeziku',
  },
  colors: {
    schwarz: 'Crna',
    weiß: 'Bijela',
    grau: 'Siva',
    rot: 'Crvena',
    blau: 'Plava',
    grün: 'Zelena',
    gelb: 'Žuta',
    rosa: 'Ružičasta',
    lila: 'Ljubičasta',
    braun: 'Smeđa',
    orange: 'Narančasta',
    beige: 'Bež',
    navy: 'Mornarsko plava',
    dunkelblau: 'Tamno plava',
    hellblau: 'Svijetlo plava',
    dunkelgrau: 'Tamno siva',
    hellgrau: 'Svijetlo siva',
    bordeaux: 'Bordo',
    türkis: 'Tirkizna',
    khaki: 'Kaki',
    mint: 'Mint',
    violett: 'Ljubičasta',
    anthrazit: 'Antracit',
    blaugrau: 'Plavo-siva',
    burgunderrot: 'Burgundska crvena',
    elfenbein: 'Bjelokost',
    karminrot: 'Karmin crvena',
    neongrün: 'Neonsko zelena',
    gelbgrün: 'Žuto-zelena',
    pistazie: 'Pistacija',
    // English color names (used in Product ID 237 etc.)
    blue: 'Plava',
    ivory: 'Bjelokost',
    green: 'Zelena',
    gold: 'Zlatna',
    red: 'Crvena',
  },
  checkout: {
    title: 'Blagajna',
    cartReview: 'Pregled narudžbe',
    orderSummary: 'Sažetak narudžbe',
    shippingInfo: 'Informacije o dostavi',
    billingInfo: 'Informacije o naplati',
    orderNotes: 'Bilješke uz narudžbu',
    orderNotesPlaceholder: 'Posebni zahtjevi ili napomene...',
    contactPerson: 'Kontakt osoba',
    phoneNumber: 'Broj telefona',
    email: 'Adresa e-pošte',
    company: 'Tvrtka',
    address: 'Adresa',
    city: 'Grad',
    postalCode: 'Poštanski broj',
    country: 'Država',
    deliveryDate: 'Datum isporuke',
    urgentDelivery: 'Ekspresna dostava (3-5 radnih dana)',
    standardDelivery: 'Standardna dostava (7-10 radnih dana)',
    placeOrder: 'Pošalji narudžbu',
    backToCart: 'Natrag na odabir proizvoda',
    requiredField: 'Obavezno polje',
    orderTotal: 'Ukupno narudžbe',
    subtotal: 'Međuzbroj',
    priceNetNotice: 'Sve cijene su neto cijene',
    stockReservationNotice: 'Rezervacija zaliha bit će izvršena nakon potvrde narudžbe.',
    stockCheckError: 'Greška pri provjeri zaliha',
    stockCheckErrorDesc: 'Došlo je do greške tijekom provjere zaliha. Molimo pokušajte ponovno.',
    shipping: 'Dostava',
    shippingCost: 'Trošak dostave',
    tax: 'Porez',
    orderSuccess: 'Narudžba uspješna',
    orderSuccessMessage: 'Vaša narudžba je uspješno poslana. Broj narudžbe: {orderNumber}',
    orderNumber: 'Broj narudžbe',
    thankYou: 'Hvala vam na narudžbi!',
    orderConfirmation: 'Vaša narudžba je uspješno poslana.',
    orderProcessing: 'Nakon pregleda od strane našeg tima, poslat ćemo vam potvrdu narudžbe putem e-pošte.',
    orderProcessingMessage: 'Vaša narudžba je uspješno poslana. Nakon pregleda od strane našeg tima, poslat ćemo vam potvrdu narudžbe putem e-pošte.',
    continueShopping: 'Nastavi kupovinu',
    emptyCart: 'Vaša košarica je prazna',
    emptyCartMessage: 'Molimo dodajte proizvode u košaricu za nastavak',
    stockWarning: 'Upozorenje o zalihama',
    stockWarningDesc: 'Neki artikli imaju nedovoljnu zalihu. Molimo prilagodite količine.',
    stockError: 'Greška zaliha',
    stockErrorDesc: 'Postoje artikli s nedovoljnom zalihom. Molimo prilagodite količine.',
    refreshStock: 'Osvježi zalihe',
    stockUpdated: 'Zalihe ažurirane',
    stockUpdatedDesc: 'Zalihe su ažurirane - {changed} artikala promijenjeno',
    stockCheckDesc: 'Prikazani su rezultati usporedbe s inventarom',
    stockOk: 'Zaliha OK',
    stockShortage: 'Nedostatak zaliha',
    requestedQty: 'Tražena kol.',
    currentStock: 'Trenutna zaliha',
    stockShortageMsg: 'Nedovoljna zaliha. Molimo prilagodite količinu.',
    stockIssueWarning: 'Narudžba se ne može potvrditi zbog problema sa zalihama.',
    stockDataMissing: 'Podaci o zalihama se preuzimaju. Molimo pričekajte trenutak.',
    outOfStock: 'Nema na zalihi.',
    maxAvailable: 'Maksimum',
    autoRestored: 'Košarica vraćena',
    autoRestoredDesc: 'Artikli iz vaše zadnje sesije su vraćeni',
    maxQuantityReached: 'Dostignuta maksimalna količina zaliha.',
    // ERP Contact Search
    contactSearch: 'Pretraga kontakata kupaca',
    contactSearchDesc: 'Unesite adresu e-pošte naručitelja za dohvaćanje kontaktnih podataka',
    emailAddress: 'Adresa e-pošte',
    searchButton: 'Pretraži',
    searching: 'Pretraživanje',
    contactFound: 'Kontakt pronađen',
    contactNotFound: 'Kontakt nije pronađen',
    contactId: 'Knitido ID kupca',
    companyName: 'Tvrtka',
    contactPersonLabel: 'Kontakt osoba',
    addressesFound: 'Pronađene adrese',
    addressType: 'Vrsta',
    addressBilling: 'Adresa za naplatu',
    addressDelivery: 'Adresa za dostavu',
    vatSourceCompany: 'Podaci o tvrtki',
    vatSourceBilling: 'Naplata',
    vatSourceDelivery: 'Dostava',
    addressOther: 'Ostalo',
    addressDetails: 'Adresa',
    loadingAddresses: 'Učitavanje podataka o adresi...',
    addressRetrieved: 'Podaci o adresi preuzeti',
    addressNotFound: 'Podaci o adresi nisu pronađeni',
    addressNotFoundDesc: 'Nema registriranih podataka o adresi. Molimo unesite ručno.',
    addressError: 'Greška pri dohvaćanju adrese',
    addressErrorDesc: 'Neuspjelo dohvaćanje podataka o adresi.',
    contactNotConfirmed: 'Kontakt kupca nije potvrđen',
    contactNotConfirmedDesc: 'Molimo unesite adresu e-pošte i pretražite kontakt.',
    searchContact: 'Pretraži kontakt',
    inputError: 'Greška unosa',
    inputErrorDesc: 'Informacije o dostavi su nepotpune. Molimo provjerite.',
    processing: 'Obrada...',
    erpContactSearch: 'Pretraga kontakata kupaca',
    contactSearchError: 'Adresa e-pošte ne odgovara nijednom registriranom kontaktu.',
    // Product Images Toggle
    showProductImages: 'Prikaži slike proizvoda',
    showProductImagesDesc: 'Prikaži slike proizvoda za bolji pregled (može produžiti vrijeme učitavanja)',
    // System Registration Info
    systemRegistrationInfo: 'Vaši podaci o kupcu',
    editShippingAddress: 'Uredi adresu za dostavu',
    systemRegistrationInfoDesc: 'Vaši registrirani poslovni podaci. Molimo kontaktirajte svog predstavnika ako trebate ažurirati detalje adrese za naplatu.',
    // Order Summary
    regularPrice: 'Redovna veleprodajna cijena',
    offeredPrice: 'Ponuđena cijena',
    discount: 'Popust',
    b2bCustomer: 'B2B Kupac',
    pattern: 'Uzorak',
    specialPriceApplied: 'Primijenjena posebna cijena',
    customerClassification: 'Klasifikacija kupca',
    paymentCondition: 'Uvjeti plaćanja',
    invoice: 'Račun (NET 30)',
    prepayment: 'Plaćanje unaprijed',
    paymentMethod: 'Način plaćanja',
    invoicePayment: 'Plaćanje po računu',
    estimatedSubtotal: 'Procijenjeni međuzbroj',
    estimatedTotal: 'Procijenjeno ukupno',
    orderSummaryDisclaimer: 'Ovdje prikazane cijene su procjene. Nakon što primimo vašu narudžbu, pregledat ćemo je i poslati vam obvezujuću potvrdu narudžbe s konačnim cijenama, troškovima dostave i porezima putem e-pošte.',
    searchError: 'Greška pretraživanja',
    searchErrorDesc: 'Došlo je do greške tijekom pretraživanja kontakta.',
    confirmDeleteItem: 'Ukloni stavku',
    itemDeleted: 'Stavka uklonjena',
    confirmDeleteItemDesc: 'Jeste li sigurni da želite ukloniti sljedeću stavku iz košarice?',
    deleteConfirm: 'Ukloni',
    contactNotes: 'Napomene za kontakt',
    contactNotesDesc: 'Imate li pitanja ili posebne zahtjeve? Molimo vas da nas obavijestite (neobavezno)',
    contactNotesLabel: 'Poruka',
    contactNotesPlaceholder: 'npr.: Pitanja o proizvodima, posebni zahtjevi, itd.',
    characters: 'znakova',
    contactIdLabel: 'Knitido ID kupca',
    companyLabel: 'Tvrtka',
    personLabel: 'Kontakt osoba',
    emailLabel: 'E-pošta',
    addressTypeLabel: 'Vrsta',
    destinationLabel: 'Odredište',
    // Shipping Form
    shippingTitle: 'Informacije o dostavi',
    shippingDesc: 'Unesite adresu za dostavu proizvoda',
    companyRequired: 'Tvrtka *',
    contactPersonRequired: 'Kontakt osoba *',
    emailRequired: 'Adresa e-pošte *',
    phoneRequired: 'Broj telefona *',
    addressRequired: 'Adresa 1 *',
    address2: 'Adresa 2 (Zgrada/Soba)',
    postalCodeRequired: 'Poštanski broj *',
    cityRequired: 'Grad *',
    countryRequired: 'Država *',
    selectCountry: 'Odaberite državu',
    shippingMethodRequired: 'Način dostave *',
    selectShippingMethod: 'Odaberite način dostave',
    urgentDeliveryOption: 'Ekspresna dostava (dodatni troškovi)',
    deliveryNotes: 'Napomene za dostavu',
    deliveryNotesPlaceholder: 'Unesite preferencije vremena dostave ili druge zahtjeve',
    standardShipping: 'Standardna dostava (3-5 radnih dana)',
    expressShipping: 'Ekspresna dostava (1-2 radna dana)',
    overnightShipping: 'Dostava preko noći',
    germany: 'Njemačka',
    austria: 'Austrija',
    switzerland: 'Švicarska',
    japan: 'Japan',
    shippingAddressLabel: 'Adresa za dostavu',
    changeDeliveryAddress: 'Promijeni adresu za dostavu',
    selectDeliveryAddress: 'Odaberi adresu za dostavu',
    // Shipping Cost Details
    freeShipping: 'Besplatna dostava',
    shippingError: 'Greška',
    shippingZone: 'Zona dostave',
    remainingForFreeShipping: 'još {amount} do besplatne dostave',
    moreForFreeShipping: 'do besplatne dostave',
    freeShippingProgress: 'Besplatna dostava na',
    andAboveFreeShipping: 'i više za besplatnu dostavu',
    freeShippingAchieved: 'Primijenjena besplatna dostava',
    threshold: 'i više',
    nextShippingTier: 'Sljedeći popust na dostavu',
    moreForDiscount: 'još za',
    shippingSavings: 'ušteda na dostavi',
    orderAmountThreshold: 'i više za',
    specialRegionNotice: 'Primijenjena posebna regija dostave',
    defaultShippingApplied: 'Primijenjene standardne cijene dostave',
    requestedQuantity: 'Tražena količina',
    availableQuantity: 'Dostupna količina',
    orderSubmitError: 'Greška narudžbe',
    orderSubmitErrorDesc: 'Nije moguće poslati narudžbu',
    upload: {
      title: 'Uvoz Excel/CSV narudžbe',
      description: 'Prenesite Excel ili CSV datoteku sa svojim podacima o narudžbi',
      dragDropOrClick: 'Povucite i ispustite datoteku ovdje ili kliknite za odabir',
      dropHere: 'Ispustite datoteku ovdje',
      supportedFormats: 'Podržani formati: Excel (.xlsx, .xls) i CSV (.csv)',
      maxSize: 'Maksimalna veličina datoteke: {size} MB',
      processFile: 'Obradi datoteku',
      processing: 'Obrada datoteke...',
      ready: 'Datoteka spremna za pregled',
      readyDescription: 'Vaša datoteka je uspješno obrađena i spremna za pregled.',
      preview: 'Prikaži pregled',
      errors: {
        fileTooLarge: 'Datoteka je prevelika. Maksimalna veličina: {size} MB',
        invalidFileType: 'Nevažeća vrsta datoteke. Molimo prenesite Excel ili CSV datoteku',
        uploadFailed: 'Greška pri prijenosu datoteke',
      },
    },
    // Loading messages
    loadingPage: 'Učitavanje stranice...',
    loadingStock: 'Provjera zaliha proizvoda...',
    loadingAccount: 'Učitavanje podataka o računu...',
    loadingError: 'Došlo je do greške...',
    loadingData: 'Učitavanje podataka',
    // Toast messages
    addressRetrievedTitle: 'Podaci o adresi preuzeti',
    addressSetAsDelivery: ' adresa postavljena kao odredište dostave.',
    contactFoundDesc: ' je prepoznat.'
  },
  orderHistory: {
    title: 'Povijest narudžbi',
    searchPlaceholder: 'Pretraži po broju narudžbe ili SKU...',
    noOrders: 'Nema pronađenih narudžbi',
    noOrdersFound: 'Nema odgovarajućih narudžbi',
    startShopping: 'Pregledaj proizvode',
    orderItems: 'Stavke narudžbe',
    viewDetails: 'Detalji',
    reorder: 'Naruči ponovno',
    orderDate: 'Datum narudžbe',
    orderStatus: 'Status',
    orderTotal: 'Ukupno narudžbe',
    // Status translations
    statusPending: 'Plaćanje na čekanju',
    statusProcessing: 'U obradi',
    statusConfirmed: 'Potvrđeno',
    statusShipped: 'Poslano',
    statusDelivered: 'Isporučeno',
    statusCancelled: 'Otkazano',
    statusReturned: 'Vraćeno',
    statusRefunded: 'Refundirano',
    statusWarranty: 'Jamstvo',
    statusExchanged: 'Zamijenjeno',
    statusRepair: 'Popravak',
    statusUnknown: 'Nepoznato',
    statusIncomplete: 'Nepotpuno',
    statusWaitingPayment: 'Čeka plaćanje',
    statusInPreparation: 'U pripremi',
    statusClearedShipping: 'Odobreno za slanje',
    statusBeingShipped: 'Slanje u tijeku',
    statusOutgoingBooked: 'Izlazno knjiženo',
    statusReturn: 'Povrat',
    // Additional UI elements
    itemCount: 'stavki',
    itemCountSingular: 'stavka',
    refreshButton: 'Osvježi',
    errorFetchingOrders: 'Neuspjelo dohvaćanje povijesti narudžbi',
    // Payment status features
    paymentStatus: 'Status plaćanja',
    markAsPaid: 'Označi kao plaćeno',
    unmarkAsPaid: 'Poništi oznaku plaćeno',
    paidOn: 'Plaćeno dana',
    paymentMarked: 'Plaćeno',
    notPaid: 'Nije plaćeno',
    paymentMarkedSuccess: 'Uspješno označeno kao plaćeno',
    paymentUnmarkedSuccess: 'Oznaka plaćanja uklonjena',
    paymentUpdateError: 'Neuspjelo ažuriranje statusa plaćanja',
    // Payment date dialog
    paymentDateTitle: 'Unesite podatke o plaćanju',
    paymentDateDescription: 'Unesite podatke o plaćanju za narudžbu {orderNumber}',
    paymentDateLabel: 'Datum plaćanja',
    selectDate: 'Odaberite datum',
    paymentDateHelp: 'Odaberite datum kada je izvršen bankovni prijenos',
    paymentMethodLabel: 'Način plaćanja',
    bankTransfer: 'Bankovni prijenos',
    invoice: 'Račun',
    otherPayment: 'Ostalo',
    paymentReferenceLabel: 'Naziv prijenosa / Referentni broj',
    paymentReferencePlaceholder: 'npr., Ivan Horvat, Prijenos #12345',
    paymentReferenceHelp: 'Unesite podatke koji pomažu pri usklađivanju s bankovnim izvodima',
    notesLabel: 'Napomene',
    notesPlaceholder: 'Unesite dodatne informacije o plaćanju',
    // Filter options
    filterByPaymentStatus: 'Filtriraj po statusu plaćanja',
    allOrders: 'Sve narudžbe',
    paidOrders: 'Plaćeno',
    unpaidOrders: 'Neplaćeno',
    // Sorting options
    sortBy: 'Sortiraj po',
    sortByDate: 'Datum narudžbe',
    sortByPaymentDate: 'Datum plaćanja',
    sortByAmount: 'Iznos',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Detalji narudžbe',
    notFound: 'Narudžba nije pronađena',
    backToHistory: 'Natrag na povijest narudžbi',
    orderDate: 'Datum narudžbe',
    orderItems: 'Stavke narudžbe',
    deliveryStatus: 'Status dostave',
    estimatedDelivery: 'Procijenjena dostava',
    deliveredOn: 'Isporučeno dana',
    downloadInvoice: 'Preuzmi račun',
    statusDelivered: 'Isporučeno',
    statusShipped: 'Poslano',
    statusConfirmed: 'Potvrđeno',
    statusCancelled: 'Otkazano',
    errorFetchingDetails: 'Neuspjelo dohvaćanje detalja narudžbe',
  },
  company: {
    name: 'Poslovni partner',
    tagline: 'Sustav za poslovne partnere',
    copyright: '© 2025 Sustav za poslovne partnere. Sva prava pridržana.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-pošta',
    countries: {
      DE: 'Njemačka',
      AT: 'Austrija',
      CH: 'Švicarska',
      FR: 'Francuska',
      IT: 'Italija',
      ES: 'Španjolska',
      NL: 'Nizozemska',
      BE: 'Belgija',
      PL: 'Poljska',
      SE: 'Švedska',
      NO: 'Norveška',
      FI: 'Finska',
      DK: 'Danska',
      LT: 'Litva',
      LV: 'Latvija',
      EE: 'Estonija',
    },
  },
  cart: {
    newCart: 'Nova košarica',
    currentCart: 'Trenutna košarica',
    modified: 'izmijenjeno',
    lastSaved: 'Zadnje spremljeno',
    unsavedChanges: 'nespremljene promjene',
    saveCart: 'Spremi košaricu',
    loadCart: 'Učitaj košaricu',
    deleteCart: 'Obriši košaricu',
    startNewCart: 'Započni novu košaricu',
    savedCarts: 'Spremljene košarice',
    cartSaved: 'Košarica spremljena',
    cartDeleted: 'Košarica obrisana',
    confirmDeleteCart: 'Obrisati košaricu?\n\nOva radnja se ne može poništiti.',
    confirmSwitchCart: 'Trenutna košarica ima nespremljene promjene.\n\nUčitavanje druge košarice uzrokovat će gubitak trenutnih promjena.\n\nNastaviti?',
    confirmSwitchCartTitle: 'Promijeni košaricu',
    confirmNewCart: 'Trenutna košarica ima nespremljene promjene.\n\nZapočinjanje nove košarice uzrokovat će gubitak trenutnih promjena.\n\nNastaviti?',
    confirmNewCartTitle: 'Započni novu košaricu',
    confirmClearCart: 'Isprazniti košaricu?\n\n{count} stavki bit će uklonjeno.\n\nOva radnja se ne može poništiti.',
    confirmClearCartTitle: 'Isprazni košaricu',
    autoSaved: 'Automatski spremljeno',
    itemsWillBeRemoved: 'stavki će biti uklonjeno',
    changesWillBeLost: 'promjene će biti izgubljene',
    continueQuestion: 'Nastaviti?',
    cartStatus: 'Status košarice',
    cartName: 'Naziv košarice',
    cartNamePlaceholder: 'npr.: Narudžba krajem mjeseca',
    cartNameRequired: 'Molimo unesite naziv košarice',
    saveCartDescription: 'Dajte naziv trenutnoj košarici i spremite je. Kasnije je možete učitati.',
    cancelCart: 'Otkaži košaricu',
    proceedToCheckout: 'Nastavi na blagajnu',
    emptyCart: 'Košarica je prazna',
    erpDown: 'Sustav narudžbi je nedostupan. Pokušajte ponovo kasnije.',
    erpDegraded: 'Sustav je trenutno nestabilan. Narudžbe mogu biti neuspješne.',
    erpDownSaveHint: 'Spremite svoju košaricu i naručite kada se sustav obnovi.',
    erpSaveCart: 'Spremi košaricu',
  },
  nav: {
    dashboard: 'Nadzorna ploča',
    products: 'Proizvodi',
    orderHistory: 'Povijest narudžbi',
    account: 'Info o računu',
    bulkImport: 'Masovni uvoz',
  },
  settings: {
    selectLanguage: 'Odaberite jezik',
    languagePreferenceSaved: 'Vaša preferencija bit će spremljena na vaš račun za buduće posjete.',
  },
  reorder: {
    allItemsAdded: '{count} stavki dodano u košaricu',
    partialSuccess: '{added} stavki dodano. {failed} stavki nije se moglo dodati',
    allItemsFailed: 'Neuspjelo dodavanje stavki u košaricu',
    error: 'Došlo je do greške tijekom ponovne narudžbe',
    itemDiscontinued: '{name} ({color}/{size}) više nije u ponudi',
    itemOutOfStock: '{name} ({color}/{size}) nije na zalihi',
    partialStock: '{name} ({color}/{size}) dostupno samo {available}',
    confirmReorder: 'Potvrdi ponovnu narudžbu',
    confirmReorderMessage: 'Dodati stavke iz ove narudžbe u vašu košaricu?',
    addingToCart: 'Dodavanje u košaricu...',
    checkingStock: 'Provjera zaliha...',
    checkoutTitle: 'Stavke dodane u košaricu',
    checkoutDescription: '{count} stavki je dodano u vašu košaricu. Želite li nastaviti na blagajnu?',
  },
  bulkImport: {
    instructions: 'Kako uvesti narudžbe',
    step1: 'Preuzmite datoteku predloška narudžbe',
    step2: 'Popunite podatke o narudžbi sa SKU i količinom',
    step3: 'Spremite kao Excel (.xlsx) ili CSV datoteku',
    step4: 'Prenesite datoteku koristeći donji obrazac',
    step5: 'Pregledajte i potvrdite svoju narudžbu',
    downloadTemplate: 'Preuzmi predložak',
    downloadExcelTemplate: 'Preuzmi Excel predložak',
    downloadCsvTemplate: 'Preuzmi CSV predložak',
    formatGuide: 'Vodič za format datoteke',
    requiredColumns: 'Obavezni stupci',
    skuDescription: 'SKU kod proizvoda',
    quantityDescription: 'Količina narudžbe (pozitivan cijeli broj)',
    optionalColumns: 'Neobavezni stupci',
    notesDescription: 'Interni zapisi (npr. broj narudžbenice, referenca) - samo za vašu evidenciju',
    formatNote: 'Prvi redak treba sadržavati zaglavlja stupaca. Podaci počinju od drugog retka.',
    parseSuccess: 'Uspješno parsirano {count} stavki iz datoteke',
    parseError: 'Greška parsiranja',
    validationError: 'Greške validacije',
    validationErrorGuidance: 'Molimo kliknite gumb "{showPreviewButton}" za pregled detalja.',
    warnings: 'Upozorenja',
    itemsParsed: 'Uspješno parsirano {count} stavki:',
    andMore: '...i još {count} stavki',
    validationSummary: 'Sažetak validacije',
    duplicateSKUs: 'Pronađeni dupli SKU-ovi',
    skuFormat: 'SKU mora sadržavati samo slova, brojeve i crtice',
    quantityRange: 'Količina mora biti između 1 i 9999',
    maxRows: 'Maksimalno 1000 redaka dopušteno',
    rowsSkipped: '{count} redaka je preskočeno zbog grešaka',
    previewTitle: 'Pregled narudžbe',
    previewDescription: 'Pregledajte i uredite podatke o narudžbi prije nastavka',
    proceedToCart: 'Dodaj u košaricu',
    // File parsing messages
    fileEmpty: 'Datoteka je prazna ili ne sadrži podatke',
    fileTooManyRows: 'Datoteka sadrži previše redaka ({current}). Maksimalno dopušteno: {max}',
    invalidRowFormat: 'Nevažeći format retka',
    missingColumns: 'Nedostaju obavezni stupci (SKU i Količina)',
    missingSku: 'Nedostaje SKU',
    invalidSkuFormat: 'Nevažeći format SKU-a: "{sku}" (mora odgovarati uzorku: {pattern})',
    skuTooLong: 'SKU predug: "{sku}" (maksimalno 50 znakova)',
    invalidQuantity: 'Nevažeća količina: "{quantity}" nije broj',
    quantityTooLow: 'Količina premala: {quantity} (minimum: {min})',
    quantityTooHigh: 'Količina prevelika: {quantity} (maksimum: {max})',
    notesRequired: 'Polje za bilješke je obavezno',
    noValidData: 'Nisu pronađeni valjani podaci. Molimo provjerite format datoteke.',
    row: 'Redak {row}: {errors}',
    rowErrors: '...i još {count} grešaka',
    duplicateSkuInRows: 'Dupli SKU "{sku}" pronađen u redcima: {rows}',
    quantityExceedsMax: 'Redak {row}: Količina {quantity} prelazi maksimalno dopušteno ({max})',
    quantityBelowMin: 'Redak {row}: Količina {quantity} je ispod minimuma ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nepodržani format datoteke. Molimo prenesite CSV ili Excel datoteku.',
    csvParsingErrors: 'Došlo je do grešaka pri parsiranju CSV-a',
    failedToParseFile: 'Neuspjelo parsiranje datoteke',
    failedToParseExcel: 'Neuspjelo parsiranje Excel datoteke',
    failedToReadFile: 'Neuspjelo čitanje datoteke',
    unknownError: 'Došlo je do nepoznate greške',
    totalRows: 'Ukupno redaka',
    valid: 'Valjano',
    invalid: 'Nevažeće',
    skipped: 'Preskočeno',
    // SKU validation
    skuValidationError: 'Greška validacije SKU-a',
    skuValidationFailed: 'Neuspjela validacija SKU-ova. I dalje možete nastaviti, ali neke stavke možda neće biti dostupne.',
    skuNotFound: 'SKU nije pronađen u bazi podataka',
    skusNotFound: '{count} SKU-ova nije pronađeno u bazi podataka',
    itemsHaveInsufficientStock: '{count} stavki ima nedovoljnu zalihu',
    validatingSKUs: 'Validacija stavki...',
    unvalidatedChanges: 'Imate nevalidirane promjene. Molimo ponovno validirajte prije dodavanja u košaricu.',
    revalidate: 'Ponovno validiraj',
    validating: 'Validacija...',
    validationSuccess: 'Sve stavke su valjane',
    validationComplete: 'Validacija završena',
    validationResultSummary: 'Pronađeno {errors} grešaka, {warnings} upozorenja',
    // Table headers
    actions: 'Radnje',
    notes: 'Bilješke',
    // Status filter
    all: 'Sve',
    hasErrors: 'Ima greške',
    // Selection summary
    selected: 'odabrano',
    errors: 'grešaka',
    // Pagination
    page: 'Stranica {current} od {total}',
    previous: 'Prethodno',
    next: 'Sljedeće',
    noResults: 'Nema rezultata.',
    // Cart integration
    noValidItems: 'Nema valjanih stavki',
    allItemsHaveErrors: 'Sve stavke imaju greške validacije. Molimo ispravite ih prije nastavka.',
    dataLoadingError: 'Greška pri učitavanju podataka',
    failedToLoadProductData: 'Neuspjelo učitavanje podataka o proizvodu. Molimo pokušajte ponovno.',
    itemsAddedToCart: '{count} stavki dodano u košaricu',
    itemsAddedMessage: 'Dodano {count} stavki u košaricu',
    someSkusNotFound: '{count} SKU-ova nije moglo biti pronađeno.',
    noItemsAdded: 'Nema dodanih stavki',
    couldNotFindProducts: 'Nije moguće pronaći proizvode koji odgovaraju SKU-ovima.',
    errorAddingToCart: 'Greška',
    failedToAddToCart: 'Neuspjelo dodavanje stavki u košaricu. Molimo pokušajte ponovno.',
    addingToCart: 'Dodavanje u košaricu...',
    // File info
    fileSelected: '{name} odabrano za obradu',
    fileSize: '{size} bajtova',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Preuzimanje predloška',
    templateWillBeImplemented: 'Preuzimanje predloška bit će implementirano u Fazi 7',
    // Additional validation
    validationFailed: 'Validacija nije uspjela',
    // Template download
    templateDownloaded: 'Predložak uspješno preuzet',
    templateDownloadError: 'Neuspjelo preuzimanje predloška',
    // Template content
    sheetName: 'Masovna narudžba',
    instructionsSheetName: 'Upute',
    columnDescriptions: 'Opisi stupaca:',
    columnHeader: 'Stupac',
    columnRequired: 'Obavezno',
    columnOptional: 'Neobavezno',
    columnDescription: 'Opis',
    templateNotes: 'Napomene:',
    templateNote1: 'Prvi redak mora sadržavati zaglavlja stupaca točno kako je prikazano',
    templateNote2: 'Podaci počinju od 2. retka',
    templateNote3: 'SKU mora odgovarati postojećim kodovima proizvoda u sustavu',
    templateNote4: 'Količina mora biti pozitivan cijeli broj između 1 i 9999',
    templateNote5: 'Maksimalno 1000 redaka dopušteno po datoteci',
    templateNote6: 'Spremite kao .xlsx ili .csv format',
    stockAvailabilityWarning: 'Stvarna dostupnost zaliha provjerit će se na sljedećoj stranici blagajne.',
    outOfStock: 'Nema na zalihi',
    insufficientStock: 'Nedovoljna zaliha: {available} dostupno, {requested} traženo',
  },
  orderExport: {
    export: 'Izvezi narudžbu',
    exportOrder: 'Izvezi podatke narudžbe',
    exportAsCSV: 'Izvezi kao CSV',
    exportAsExcel: 'Izvezi kao Excel',
    exportForReorder: 'Izvezi za masovni uvoz',
    detailed: 'Puni detalji',
    simpleFormat: 'Format za uvoz',
  },
};
